<template>
  <v-hover v-slot="{ hover }">
    <v-card
    :data-testid="dataTestid" outlined :elevation="hover ? 4 : 1" @click="onclick">
      <v-list-item :class="`${color}`">
        <v-list-item-icon>
          <v-icon x-large color="white">{{ icon }}</v-icon></v-list-item-icon
        >
        <v-list-item-content>
          <v-list-item-title class="white--text text-h4">
            {{ titre }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-card-text style="height: 300px" class="pa-4">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <span :class="`${color}--text`">
          <slot name="actions"></slot>
        </span>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
export default {
  props: {
    "data-testid": {
      type: String,
      required: false,
    },
    icon: {
      type: String,
      required: true,
    },
    titre: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
  },
  methods: {
    onclick() {
      this.$emit("click", this);
    },
  },
};
</script>
